/*
 *   File : sub-admin-navigation.js
 *   Author URI : www.evoqins.com
 *   Description : Navigation items
 *   Integrations : js-cookie
 *   Version : v1.0
 *   Created : 07-11-2023
 */
/*import package*/
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

/*import styles*/
import style from '../../Styles/Components/navigation-item.module.scss';

/*import components*/
import Icon from "../Icon/icon";
import Store from "../../Store";
import { CustomLoader } from "../Other";

import { _logout } from "../../Helper/api";

/*import store*/

const SubAdminNavigation = (props) => {

    const location = useLocation();
    const navigator = useNavigate();

    const NAVIGATION = useSelector(state => state.MT_ADMIN_STORE.path);
    const SIDEBAR_TOGGLE = useSelector(state => state.MT_ADMIN_STORE.toggle);
    const ADMIN_PROFILE_DATA = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);
    console.log('ADMIN_PROFILE_DATA', ADMIN_PROFILE_DATA);


    const DASHBOARD_OPTIONS = [
        {
            name: "User summary",
            link: "/user-summary",
            short_name: 'user_summary',
            image_color: require("../../Assets/Images/Sidebar/users-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/users-gray.png"),
        },
        {
            name: "Orders list",
            link: "/order-book",
            short_name: 'order_book',
            image_color: require("../../Assets/Images/Sidebar/orders-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/orders-gray.png"),

        },
        {
            name: "Explore",
            link: "/explore",
            short_name: 'explore',
            image_color: require("../../Assets/Images/Sidebar/explore-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/explore-gray.png"),
            show_always: true
        },
        {
            name: "Compare funds",
            link: "/compare-funds",
            short_name: 'explore',
            image_color: require("../../Assets/Images/Sidebar/compare-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/compare-gray.png"),
            show_always: true
        },
        // {
        //     name: 'Invest in Goals',
        //     link: "/goal",
        //     short_name: 'goal',
        //     image_color: require("../../Assets/Images/Sidebar/invest-in-goals-color.png"),
        //     image_gray: require("../../Assets/Images/Sidebar/invest-in-goals-gray.png"),
        //     show_always: true
        // },
        {
            name: "Manage sub admins",
            link: "/manage-sub-admin",
            short_name: 'manage_sub_admin',
            image_color: require("../../Assets/Images/Sidebar/manage-subadmin-active.svg").default,
            image_gray: require("../../Assets/Images/Sidebar/manage-subadmin.svg").default,
        },
        {
            name: "Manage funds",
            link: "/manage-fund",
            short_name: 'manage_fund',
            image_color: require("../../Assets/Images/Sidebar/manage-fund-active.svg").default,
            image_gray: require("../../Assets/Images/Sidebar/manage-fund.svg").default,

        },
        {
            name: "Manage SIPs",
            link: "/sip-manage",
            short_name: 'sip_manage',
            image_color: require("../../Assets/Images/Sidebar/sip-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/sip-gray.png"),
        },
        {
            name: "Manage STP & SWP",
            link: "/manage-stp-swp",
            short_name: 'swp_stp_manage',
            image_color: require("../../Assets/Images/Sidebar/swp&stp-active.png"),
            image_gray: require("../../Assets/Images/Sidebar/swp&stp.png"),
            // show_always: true
        },
        // {
        //     name: "Manage Branch/RM",
        //     link: "#",
        //     image_color: require("../../Assets/Images/Sidebar/manage-branch-color.png"),
        //     image_gray: require("../../Assets/Images/Sidebar/manage-branch-gray.png"),
        // },
        {
            name: "Manage content",
            link: "/manage-content",
            short_name: 'manage_content',
            image_color: require("../../Assets/Images/Sidebar/content-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/content-gray.png"),

        },
        {
            name: "Manage Others",
            link: "/onboarding",
            short_name: 'manage_onboarding',
            image_color: require("../../Assets/Images/Sidebar/huf-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/huf-gray.png"),
            // show_always: ADMIN_PROFILE_DATA.admin_type_id <= 3 ? true : undefined
        },
        // {
        //     name: "Dashboard",
        //     link: "/dashboard",
        //     image_color: require("../../Assets/Images/Sidebar/dashboard-color.png"),
        //     image_gray: require("../../Assets/Images/Sidebar/dashboard-gray.png"),
        // },
        // {
        //     name: "Push notifications",
        //     link: "/push-notifications",
        //     image_color: require("../../Assets/Images/Sidebar/notifications-gray.png"),
        //     image_gray: require("../../Assets/Images/Sidebar/notifications-color.png"),
        //     short_name: "sip_manage"
        // },
        {
            name: "Manage dashboard",
            link: "/general-settings",
            short_name: 'general_settings',
            image_color: require("../../Assets/Images/Sidebar/others-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/others-gray.png"),
        },
        // {
        //     name: "Manage NFT",
        //     link: "#",
        //     image_color: require("../../Assets/Images/Sidebar/manage-nft-color.png"),
        //     image_gray: require("../../Assets/Images/Sidebar/manage-nft-gray.png"),
        // },
        {
            name: "Manage quiz",
            link: "/risk-planning-questionnaire",
            short_name: 'risk_planning_questionnaire',
            image_color: require("../../Assets/Images/Sidebar/quiz-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/quiz-gray.png"),
        },
        {
            name: "Order execution",
            link: "/place-order",
            short_name: 'place_order',
            image_color: require("../../Assets/Images/Sidebar/execution-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/execution-gray.png"),
            show_always: true
        },
        {
            name: "Manage onboarding",
            link: "/manage-onboarding",
            short_name: 'manage_onboarding',
            image_color: require("../../Assets/Images/Sidebar/onboarding-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/onboarding-gray.png"),
        },
        {
            name: "White label settings",
            link: "/white-label-settings",
            short_name: 'manage_onboarding',
            image_color: require("../../Assets/Images/Sidebar/white-label-settings-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/white-label-settings-gray.png"),
        },
        {
            name: "Revenue report",
            link: "/revenue-report",
            short_name: 'revenue_report',
            image_color: require("../../Assets/Images/Sidebar/report-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/report-gray.png"),
            show_always: true
        },
        {
            name: "Calendar view",
            link: "/sip-calendar",
            short_name: 'manage_onboarding',
            image_color: require("../../Assets/Images/Sidebar/sip-calender.png"),
            image_gray: require("../../Assets/Images/Sidebar/sip-calender-inactive.png"),
        },
        {
            name: "KYC reasons",
            link: "/kyc-rejection-reasons",
            short_name: 'admin_settings',
            image_color: require("../../Assets/Images/Sidebar/settings-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/settings-gray.png"),
        },

        {
            name: "Manage KYC request",
            link: "/kyc-request",
            short_name: 'manage_kyc_request',
            image_color: require("../../Assets/Images/Sidebar/settings-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/settings-gray.png"),
            show_always: true
        },

        {
            name: "Manage Hierarchy",
            link: "/manage-hierarchy",
            short_name: 'manage-hierach',
            image_color: require("../../Assets/Images/Sidebar/manage-subadmin-active.svg").default,
            image_gray: require("../../Assets/Images/Sidebar/manage-subadmin.svg").default,
            // show_always: true
        },
        {
            name: "Manage Reports",
            link: "/manage-reports",
            short_name: 'manage-reports',
            image_color: require("../../Assets/Images/Sidebar/manage-subadmin-active.svg").default,
            image_gray: require("../../Assets/Images/Sidebar/manage-subadmin.svg").default,
            show_always: true
        },

        // {
        //     name: "Obligation Reports",
        //     link: "/obligation-reports",
        //     short_name: 'obligation-reports',
        //     image_color: require("../../Assets/Images/Sidebar/report-color.png"),
        //     image_gray: require("../../Assets/Images/Sidebar/report-gray.png"),
        //     show_always: true
        // },

        {
            name: "Login logs",
            link: "/login-logs",
            short_name: 'login_logs',
            image_color: require("../../Assets/Images/Sidebar/login-log-color.png"),
            image_gray: require("../../Assets/Images/Sidebar/login-log-gray.png"),
        },

    ];

    const [show, setShow] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [menuItems, setMenuItems] = useState(DASHBOARD_OPTIONS);
    console.log('menuItems', menuItems);

    const [logoutLoader, setLogoutLoader] = useState(false);



    // filtering sidebar depending on permissions
    useEffect(() => {
        const permission_details = ADMIN_PROFILE_DATA.permission_details || [];

        const filtered_dashboard_options = DASHBOARD_OPTIONS.filter(option =>
            permission_details.some(permission =>
                option.short_name === permission.short_name || option.show_always === true
            )
        );

        // Forcefully adding manage hierarchy menu for sub-admin (ops)
        if (filtered_dashboard_options.length >= 1 && ADMIN_PROFILE_DATA.admin_type_id === 2) {
            const manageHierarchyOption = DASHBOARD_OPTIONS.find(option => option.link === "/manage-hierarchy");
            const hasManageHierarchy = filtered_dashboard_options.some(option => option.link === "/manage-hierarchy");
            if (manageHierarchyOption && hasManageHierarchy === false) {
                const insertIndex = Math.max(filtered_dashboard_options.length - 1, 1);
                filtered_dashboard_options.splice(insertIndex, 0, manageHierarchyOption);
            }
        }



        if (filtered_dashboard_options.length > 0) {
            setMenuItems(filtered_dashboard_options);
        } else {
            setMenuItems(DASHBOARD_OPTIONS);
        }
    }, [ADMIN_PROFILE_DATA]);

    useEffect(() => {
        const handleNavigation = () => {
            // This function will be called on navigation changes
            const modal_element = document.querySelector('.modal-backdrop');
            if (modal_element) {
                modal_element.remove()
            }
        };

        // Add event listener for the 'popstate' event
        window.addEventListener('popstate', handleNavigation);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('popstate', handleNavigation);
        };

    }, []);

    useEffect(() => {
        setShow(SIDEBAR_TOGGLE);
    }, [SIDEBAR_TOGGLE]);


    useEffect(() => {
        Store.dispatch({
            type: 'UPDATE_NAVIGATION', payload: location.pathname
        })
        //eslint-disable-next-line
    }, [location.pathname]);

    // redirection
    const _handleNavigation = (link) => {
        setShowMenu(false);
        navigator(link);
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    };

    // show and hide complete dashboard 
    const _handleSidebarToggle = () => {
        Store.dispatch({
            type: 'TOGGLE_SIDEBAR', payload: !show
        })
    }

    const _handleShowMenu = (menu_status) => {
        setShowMenu(menu_status);
    }

    function _handleLogout() {
        setLogoutLoader(true);
        _logout();
    }

    // prevent unwanted re render when redux update;
    const memoizedNavigationItems = useMemo(() => {
        // Matching the detail page
        const route_nodes = NAVIGATION.split("/");


        // if array length more than 2 means detail page taking the 1st node from url 
        const index_page = (route_nodes.length >= 2) ? `/${route_nodes[1]}` : NAVIGATION;
        return (
            menuItems.map((item, key) => {
                return (
                    <div key={key}
                        className={`e-font-16 d-flex align-items-center gap-8px py-2 padding-10px-lr margin-12px-bottom cursor-pointer white-space-nowrap 
                        ${item.link === index_page ?
                                `color-charleston-green e-poppins-semi-bold  border-left-2px ` :
                                `color-black e-poppins-regular ${style.e_navigation_items}`
                            }
                        `}
                        onClick={() => _handleNavigation(item.link)}>
                        <img draggable={false}
                            src={
                                item.link === index_page
                                    ? item.image_color
                                    : item.image_gray
                            }
                            width={24}
                            height={24}
                            alt={item.name} />

                        <p className="my-0">{item.name}</p>

                    </div>
                );
            })
        )
        //eslint-disable-next-line
    }, [menuItems, NAVIGATION]);

    const memoizedToggledNavigationItems = useMemo(() => {
        // Matching the detail page
        const route_nodes = NAVIGATION.split("/");

        // if array length more than 2 means detail page taking the 1st node from url 
        const index_page = (route_nodes.length >= 2) ? `/${route_nodes[1]}` : NAVIGATION;

        return (
            menuItems.map((item, key) => {
                return (
                    <div key={key}
                        className={`e-font-16 d-flex align-items-center justify-content-center gap-8px margin-12px-bottom cursor-pointer white-space-nowrap `}
                        onClick={() => {
                            _handleNavigation(item.link);
                        }}>
                        <span className={`${item.link === index_page ?
                            `color-charleston-green e-poppins-semi-bold py-2 padding-10px-lr  border-left-2px ` :
                            `color-black e-poppins-regular py-2 padding-10px-lr ${style.e_navigation_items}`
                            }
                        `}>
                            <img draggable={false}
                                src={
                                    item.link === index_page
                                        ? item.image_color
                                        : item.image_gray
                                }
                                width={24}
                                height={24}
                                alt={item.name}
                            />
                        </span>

                    </div>
                );
            })
        )
        //eslint-disable-next-line
    }, [menuItems, NAVIGATION]);

    return (
        <>
            {
                logoutLoader === true ? (
                    <div className="position-fixed w-100 h-100 top-0 left-0 z-index-10">
                        <CustomLoader />
                    </div>
                ) : (
                    <>
                        <div style={{ zIndex: 1000 }} className="border-right-1px bg-pastel-blue position-fixed top-0  h-100 overflow-visible e-side-bar d-lg-block d-none ps-2 padding-10px-right" >
                            <div className="d-flex align-items-center justify-content-center pt-3 margin-20px-bottom e-sidebar-logo e-zoom-out-wrapper">

                                {
                                    show ?
                                        <img draggable={false}
                                            width={41}
                                            height={41}
                                            src={require("../../Assets/Images/Sidebar/toggle-mt-logo.svg").default}
                                            alt="Master Trust logo"
                                            className="mb-4 cursor-pointer"
                                            onClick={() => {
                                                navigator("/")
                                            }} />
                                        :
                                        <>

                                            <p className="color-jett-black e-poppins-regular e-font-8 mb-0 p-1 bg-sky-blue position-absolute top-10px end-0 e-admin-type">
                                                {ADMIN_PROFILE_DATA.admin_type}
                                            </p>

                                            <img draggable={false}
                                                src={require("../../Assets/Images/Sidebar/master-trust-logo.svg").default}
                                                alt="Master Trust logo"
                                                className="cursor-pointer"
                                                onClick={() => {
                                                    navigator("/")
                                                }} />
                                        </>
                                }

                            </div>



                            <div className={`${style.e_menu_item_wrapper} position-relative left-0 right-0 margin-auto e-zoom-out-wrapper e-sidebar-menu-wrapper ${show ? 'w-100' : ''}`}>


                                {
                                    show ?
                                        memoizedToggledNavigationItems
                                        :
                                        memoizedNavigationItems
                                }

                                {
                                    show ?
                                        <div className={`color-black e-poppins-regular e-font-16 d-flex align-items-center justify-content-center gap-8px py-2 padding-10px-lr cursor-pointer ${style.e_navigation_items}`}
                                            onClick={_handleLogout}>
                                            <img draggable={false}
                                                src={require('../../Assets/Images/Sidebar/logout-gray.png')}
                                                width={24}
                                                height={24}
                                                alt="Logout" />

                                        </div>
                                        :

                                        <div className={`color-black e-poppins-regular e-font-16 d-flex align-items-center gap-8px py-2 padding-10px-lr cursor-pointer ${style.e_navigation_items}`}
                                            onClick={_handleLogout}>
                                            <img draggable={false}
                                                src={require('../../Assets/Images/Sidebar/logout-gray.png')}
                                                width={24}
                                                height={24}
                                                alt="Logout" />
                                            <p className="my-0">
                                                Logout
                                            </p>
                                        </div>
                                }
                            </div>

                            {
                                show ?
                                    <Icon icon="toggle-inactive"
                                        width="24px"
                                        height="24px"
                                        className="e-toggle-icon-responsive "
                                        onClick={_handleSidebarToggle} />
                                    :
                                    <Icon icon="toggle-active"
                                        width="24px"
                                        height="24px"
                                        className="e-toggle-icon"
                                        onClick={_handleSidebarToggle} />
                            }


                        </div >

                        {/* mobile view */}
                        <div className='d-lg-none d-block'>
                            <div className='d-flex justify-content-between align-items-center ps-4 pt-3'>
                                <img draggable={false} src={require('../../Assets/Images/Sidebar/drawer.svg').default} alt="Menu"

                                    onClick={() => {
                                        _handleShowMenu(true);
                                    }} />
                            </div>

                        </div>
                        {
                            showMenu &&
                            <div className="border-right-1px bg-alice-blue h-150vh overflow-visible e-side-bar d-lg-none d-block px-4 w-100 position-absolute top-0 z-index-12" >
                                <div className="d-flex align-items-center justify-content-start pt-3 margin-20px-bottom e-sidebar-logo e-zoom-out-wrapper position-relative">


                                    <img draggable={false}
                                        src={require("../../Assets/Images/Sidebar/master-trust-logo.svg").default}
                                        alt="Master Trust logo" />

                                    <Icon icon="close"
                                        size={24}
                                        className="position-absolute e-close top-20px end-0 cursor-pointer"
                                        onClick={() => {
                                            _handleShowMenu(false)
                                        }} />


                                </div>



                                <div className={`${style.e_menu_item_wrapper} position-relative left-0 right-0  e-zoom-out-wrapper e-sidebar-menu-wrapper ${props.toggle ? 'w-100' : ''}`}>

                                    {/* navigation items */}

                                    {
                                        show ?
                                            memoizedToggledNavigationItems
                                            :
                                            memoizedNavigationItems
                                    }

                                    {
                                        show ?
                                            <div className={`color-black e-poppins-regular e-font-16 d-flex align-items-center justify-content-center gap-8px py-2 padding-10px-lr margin-58px-top cursor-pointer ${style.e_navigation_items}`}
                                                onClick={_handleLogout}>
                                                <img draggable={false}
                                                    src={require('../../Assets/Images/Sidebar/logout-gray.png')}
                                                    width={24}
                                                    height={24}
                                                    alt="Logout" />

                                            </div>
                                            :

                                            <div className={`color-black e-poppins-regular e-font-16 d-flex align-items-center gap-8px py-2 padding-10px-lr margin-58px-top cursor-pointer ${style.e_navigation_items}`} onClick={_handleLogout}>
                                                <img draggable={false}
                                                    src={require('../../Assets/Images/Sidebar/logout-gray.png')}
                                                    width={24}
                                                    height={24}
                                                    alt="Logout" />
                                                <p className="mb-0">
                                                    Logout
                                                </p>
                                            </div>
                                    }
                                </div>

                            </div >
                        }
                    </>
                )
            }
        </>
    )
}

export default SubAdminNavigation;
